import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Avatar from '@eversports/klimt-primitives/legacy/Avatar'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../../localization/react'
import NotificationTimeStamp from '../NotificationTimeStamp'

import type { FakeNotification } from './NotificationPromotion.types'

interface Props {
  notification: FakeNotification
}

const FakeNotification = ({ notification }: Props) => {
  return (
    <Box
      sx={{
        padding: 4,
        border: '1px solid',
        borderColor: 'mediumgray',
        borderRadius: 1,
        backgroundColor: 'white',
        boxShadow: boxShadows.hover,
        position: 'relative',
      }}
    >
      <Stack direction="row" alignItems="flex-start" gap={4}>
        <Avatar
          src={notification.icon}
          sx={{
            height: '42px',
            width: '42px',
            backgroundColor: 'white',
            borderRadius: 10,
          }}
        />
        <Stack gap={1} width="100%">
          <Text sx={{ color: 'midnight', fontWeight: 'bold' }}>
            <Localized id={notification.headerTextKey} />
          </Text>
          <NotificationTimeStamp createdAt={notification.created} isNew={true} />
        </Stack>
      </Stack>
    </Box>
  )
}

export default FakeNotification
